import {CronWorkflowContainer} from './cron-workflow-container';

export default {
    component: CronWorkflowContainer
};
